import { apiSlice } from '@/store/api/apiSlice';

export interface Message {
  id: string;
  userId: string | null;
  type: string;
  name: string;
  email: string;
  contactNo: string | null;
  message: string | null;
  feedbackStatus: string | null;
  mailSent: boolean;
  mailSentAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface MessageResponse {
  data: Message[];
  count: number;
  skip: number;
  take: number;
}

export const messageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMessageList: builder.query<
      MessageResponse,
      { skip: number; take: number; type?: string }
    >({
      query: ({ skip, take, type = 'Wishlist' }) => ({
        url: `/message?skip=${skip}&take=${take}&type=${type}`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMessageListQuery,
  useLazyGetMessageListQuery,
} = messageApi;
